export function formatOtp(value: string) {
  const digits = value.replace(/\D/g, "").slice(0, 6)
  return digits.length > 3 ? `${digits.slice(0, 3)} ${digits.slice(3)}` : digits
}

export function normalizeSecondFactor(value: string) {
  const trimmed = value.trim()
  if (/^[\d\s]*$/.test(trimmed)) return formatOtp(trimmed)
  return trimmed
    .toUpperCase()
    .replace(/[^A-Z0-9-]/g, "")
    .slice(0, 32)
}

export function rawSecondFactor(value: string) {
  return value.replace(/\s/g, "")
}

export function normalizeDecimalInput(value: string, scale = 2) {
  const normalized = value.replace(".", ",").replace(/[^\d,]/g, "")
  const [whole = "", ...fractions] = normalized.split(",")
  const fraction = fractions.join("").slice(0, Math.max(0, scale))
  const safeWhole = whole.replace(/^0+(?=\d)/, "").slice(0, 12)
  return fractions.length && scale > 0 ? `${safeWhole || "0"},${fraction}` : safeWhole
}
